/**
 * Governance i18n — Central entry point
 *
 * Usage in any component:
 *   import { getGovernanceT } from '../../i18n/governance';
 *   import { useGovernanceLang } from '../../contexts/GovernanceLangContext';
 *
 *   const { lang } = useGovernanceLang();
 *   const T = getGovernanceT(lang).governance.controlTower;
 *   // or: const t = getGovernanceT(lang);
 *   //     t.governance.onboarding.title
 *
 * Future react-i18next migration:
 *   Replace getGovernanceT(lang).governance.X.Y → t('governance.X.Y')
 *   Keys are already dot-notation compatible — no structural refactoring.
 */
import pt from './pt';
import en from './en';

/**
 * @param {'pt'|'en'} lang
 * @returns {typeof pt}
 */
export function getGovernanceT(lang) {
  return lang === 'en' ? en : pt;
}

export { pt, en };
